import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { AlertTriangle, ArrowRight } from "lucide-react";
import api from "@/lib/api";

// Dashboard-Warnung: erscheint nur, wenn in den letzten 24 h SMS nicht angekommen sind.
export function SmsHealthWarning() {
  const [h, setH] = useState(null);
  useEffect(() => {
    api.get("/admin/sms-stats/health").then((r) => setH(r.data)).catch(() => setH(null));
  }, []);
  if (!h?.failed_24h) return null;
  return (
    <Link to="/admin/sms-stats?status=failed" data-testid="dashboard-sms-warning"
          className="mb-4 flex items-center gap-3 rounded-2xl border border-rose-500/40 bg-rose-500/10 hover:bg-rose-500/15 px-4 py-3 transition-colors group">
      <div className="h-9 w-9 shrink-0 rounded-xl bg-rose-500/20 flex items-center justify-center">
        <AlertTriangle size={16} className="text-rose-300" />
      </div>
      <div className="flex-1 min-w-0">
        <div className="text-[14px] font-bold text-rose-100" data-testid="dashboard-sms-warning-count">
          {h.failed_24h} {h.failed_24h === 1 ? "SMS ist" : "SMS sind"} in den letzten 24 h nicht angekommen
        </div>
        {h.last_reason_de && <div className="text-[12px] text-rose-200/80 truncate">Zuletzt: {h.last_reason_de}</div>}
      </div>
      <ArrowRight size={16} className="text-rose-300 group-hover:translate-x-0.5 transition-transform" />
    </Link>
  );
}
